/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type TenantAvailabilityState = 1 | 2 | 3;

export const TenantAvailabilityState = {
    NUMBER_1: 1 as TenantAvailabilityState,
    NUMBER_2: 2 as TenantAvailabilityState,
    NUMBER_3: 3 as TenantAvailabilityState
};

